import { atom } from 'recoil'

export const newFormIdAtom = atom({
    key: 'newFormId',
    default: -1,
})

export const newFormServiceTypeAtom = atom({
    key: 'newFormServiceType',
    default: '',
})

export const formTypeAtom = atom({
    key: 'formType',
    default: '',
})

export const formIdAtom = atom({
    key: 'formId',
    default: -1,
})

export const recordIdAtom = atom({
    key: 'recordId',
    default: -1,
})

export const recoveryIdAtom = atom({
    key: 'recoveryId',
    default: -1,
})

export const formLoadedAtom = atom({
    key: 'formLoaded',
    default: false,
})

export const fieldChangedAtom = atom({
    key: 'fieldChanged',
    default: false,
})

export const lockedLevelsAtom = atom({
    key: 'lockedLevels',
    default: 0
})

export const recordLockLevelAtom = atom({
    key: 'recordLockLevel',
    default: 0
})

